export const TEXT_TYPES = ['string', 'text', 'number'];
export const SELECT_TYPES = ['select', 'month'];
export const FILE_TYPES = ['image', 'file'];

export const SINGLE = 'single';
export const MULTIPLE = 'multiple';

export type QUESTION_TYPES = SINGLE | MULTIPLE;
